import { dataSet } from "../../main/data/data";
export function submitEditURL(e) {
    const target = e.target;
    if (target.classList && target.classList.contains("cp-edit-urls__form")) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const select = target.querySelector(".cp-edit-urls__select");
        const input = target.querySelector(".cp-edit-urls__url");
        const status = target.querySelector(".cp-edit-urls__status");
        status.innerHTML = "";
        if (select.value && input.value) {
            const button = target.querySelector(".cp-edit-urls__submit");
            // const url = new URL(input.value);
            // const encodedUrl = url.origin + url.pathname + encodeURIComponent(url.search + url.hash);
            const encodedUrl = input.value;
            button.disabled = true;
            dataSet(`active/${select.value}/url`, encodedUrl)
                .then(() => {
                status.innerHTML = "Done!";
                button.disabled = false;
            })
                .catch(() => {
                status.innerHTML = "Error!";
                button.disabled = false;
            });
        }
    }
}
